import { days, OpenHours } from "@/app/Offices/Utils/days";
import dayjs from "dayjs";
import { cn } from "@/lib/utils";

export function OpenHoursViewState({
  openHours,
  parentOpenHours,
}: {
  openHours: OpenHours;
  parentOpenHours?: OpenHours;
}) {
  return (
    <div className="col-span-full overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      <div className="grid grid-cols-7 divide-x divide-slate-200">
        {days.map((day) => {
          const isClosed = openHours[day]?.length === 0;

          const isDifferentFromParent =
            parentOpenHours &&
            JSON.stringify(parentOpenHours[day]) !==
              JSON.stringify(openHours[day]);

          const parentHours = parentOpenHours?.[day].at(0);

          return (
            <div
              key={day}
              className={cn("p-4 text-center", {
                "bg-red-50": isClosed,
                "bg-slate-50": !isClosed,
              })}
            >
              <div className="mb-2">
                <div className="text-sm font-medium capitalize text-slate-900">
                  {day}
                </div>
              </div>
              <div className="space-y-1">
                {isClosed ? (
                  <div className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-1 text-xs font-medium text-red-800">
                    CLOSED
                  </div>
                ) : (
                  openHours[day]?.map((hours) => {
                    const [start, end] = hours.split("-");
                    const is24Hours =
                      (start === "00:00" && end === "24:00") ||
                      (start === "0:00" && end === "24:00");

                    if (is24Hours) {
                      return (
                        <div className="space-y-1" key={hours}>
                          {isDifferentFromParent && parentHours ? (
                            <div className="text-xs text-red-500 line-through">
                              {parentHours === "00:00-24:00" ||
                              parentHours === "0:00-24:00" ? (
                                "24hrs"
                              ) : (
                                <>
                                  {dayjs(
                                    parentHours.split("-")[0],
                                    "HH:mm",
                                  ).format("h:mma")}{" "}
                                  -{" "}
                                  {parentHours.split("-")[1] === "24:00"
                                    ? "12:00am"
                                    : dayjs(
                                        parentHours.split("-")[1],
                                        "HH:mm",
                                      ).format("h:mma")}
                                </>
                              )}
                            </div>
                          ) : null}
                          <div className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-1 text-xs font-medium text-green-800">
                            24hrs
                          </div>
                        </div>
                      );
                    }

                    const startTime = dayjs(start, "HH:mm").format("h:mma");
                    const endTime =
                      end === "24:00"
                        ? "12:00am"
                        : dayjs(end, "HH:mm").format("h:mma");

                    return (
                      <div className="space-y-1" key={hours}>
                        {isDifferentFromParent && parentHours ? (
                          <div className="text-xs text-red-500 line-through">
                            {parentHours === "00:00-24:00" ||
                            parentHours === "0:00-24:00" ? (
                              "24hrs"
                            ) : (
                              <>
                                {dayjs(
                                  parentHours.split("-")[0],
                                  "HH:mm",
                                ).format("h:mma")}{" "}
                                -{" "}
                                {parentHours.split("-")[1] === "24:00"
                                  ? "12:00am"
                                  : dayjs(
                                      parentHours.split("-")[1],
                                      "HH:mm",
                                    ).format("h:mma")}
                              </>
                            )}
                          </div>
                        ) : null}
                        <div className="text-sm font-semibold text-slate-900">
                          {startTime}
                        </div>
                        <div className="text-xs text-slate-500">to</div>
                        <div className="text-sm font-semibold text-slate-900">
                          {endTime}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
